import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = () => {
    const personStructuredData = {
        "@context": "https://schema.org",
        "@type": "Person",
        "name": "Ashu Kumar",
        "url": "https://www.ashukumar.com",
        "image": "%PUBLIC_URL%/images/user-3.jpg",
        "sameAs": [
            "https://linkedin.com/in/catchashu10",
            "https://github.com/catchashu10"
        ],
        "jobTitle": "Software Developer",
        "worksFor": {
            "@type": "Organization",
            "name": "University of Wisconsin-Madison"
        },
        "alumniOf": {
            "@type": "Organization",
            "name": "Indian Institute of Technology Dhanbad"
        },
        "knowsAbout": [
            "Distributed Systems",
            "Machine Learning",
            "Cloud Solutions",
            "API Development",
            "Web Design",
            "Big Data Analytics"
        ],
        "hasOccupation": {
            "@type": "Occupation",
            "name": "Software Developer",
            "skills": [
                "C++",
                "Python",
                "React",
                "AWS",
                "Docker",
                "Kubernetes",
                "Machine Learning",
                "Distributed Systems"
            ]
        }
    };

    const portfolioStructuredData = {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        "name": "Ashu Kumar's Portfolio",
        "description": "Software development projects showcasing expertise in distributed systems, machine learning, and cloud solutions",
        "url": "https://www.ashukumar.com/#projects",
        "author": {
            "@type": "Person",
            "name": "Ashu Kumar"
        },
        "hasPart": [
            {
                "@type": "SoftwareSourceCode",
                "name": "Distributed Key-Value Store",
                "programmingLanguage": ["C++"],
                "description": "Building scalable and resilient distributed systems that can handle high loads with low latency",
                "technologies": ["gRPC", "RocksDB"]
            },
            {
                "@type": "SoftwareSourceCode",
                "name": "ML-based Recommendation System",
                "programmingLanguage": ["Python"],
                "description": "Developing and deploying machine learning models that solve real-world problems efficiently",
                "technologies": ["TensorFlow", "AWS"]
            },
            {
                "@type": "SoftwareSourceCode",
                "name": "Cloud-based Content Delivery Network",
                "description": "High-performance content delivery network built on AWS infrastructure",
                "technologies": ["AWS CloudFront", "Lambda", "S3"]
            }
        ]
    };

    return (
        <Helmet>
            <html lang="en" />
            <title>Ashu Kumar - Software Developer & Distributed Systems Engineer | Portfolio</title>
            <meta name="description" content="Ashu Kumar is a Software Developer at UW-Madison, specializing in Distributed Systems, Machine Learning, and Cloud Solutions. View my projects and technical expertise in C++, Python, AWS, and more." />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="profile" />
            <meta property="og:url" content="https://www.ashukumar.com" />
            <meta property="og:title" content="Ashu Kumar - Software Developer & Distributed Systems Engineer | Portfolio" />
            <meta property="og:description" content="Software Developer at UW-Madison, specializing in Distributed Systems, Machine Learning, and Cloud Solutions. Expert in C++, Python, AWS." />
            <meta property="og:image" content="%PUBLIC_URL%/images/user-3.jpg" />
            <meta property="og:image:alt" content="Ashu Kumar - Software Developer" />
            <meta property="og:site_name" content="Ashu Kumar's Portfolio" />
            <meta property="profile:first_name" content="Ashu" />
            <meta property="profile:last_name" content="Kumar" />
            <meta property="profile:username" content="catchashu10" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content="https://www.ashukumar.com" />
            <meta name="twitter:title" content="Ashu Kumar - Software Developer & Distributed Systems Engineer" />
            <meta name="twitter:description" content="Software Developer at UW-Madison, specializing in Distributed Systems, ML, and Cloud. View my portfolio of innovative projects." />
            <meta name="twitter:image" content="%PUBLIC_URL%/images/user-3.jpg" />
            <meta name="twitter:image:alt" content="Ashu Kumar - Software Developer" />

            {/* Keywords and additional meta tags */}
            <meta name="keywords" content="Software Developer, Distributed Systems, Machine Learning, Cloud Solutions, Full Stack Engineer, API Development, Web Design, C++, Python, AWS, Docker, Kubernetes, TensorFlow, gRPC, RocksDB, University of Wisconsin-Madison" />
            <meta name="author" content="Ashu Kumar" />
            <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
            <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
            <link rel="canonical" href="https://www.ashukumar.com" />

            {/* Locale */}
            <meta property="og:locale" content="en_US" />
            <meta name="language" content="English" />

            {/* Color scheme */}
            <meta name="theme-color" content="#FF9000" />
            <meta name="msapplication-TileColor" content="#FF9000" />

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify(personStructuredData)}
            </script>
            <script type="application/ld+json">
                {JSON.stringify(portfolioStructuredData)}
            </script>

            {/* Performance optimizations */}
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
            <link rel="dns-prefetch" href="https://fonts.googleapis.com" />
            <link rel="dns-prefetch" href="https://fonts.gstatic.com" />

            {/* Mobile optimization */}
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
            <meta name="format-detection" content="telephone=no" />
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />

            {/* RSS Feed */}
            <link rel="alternate" type="application/rss+xml" title="Ashu Kumar's Blog Feed" href="https://www.ashukumar.com/feed.xml" />
        </Helmet>
    );
};

export default SEO; 